import { useState, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import "@fontsource/montserrat";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AppRoutes from "./routes.js";
import Loader from "./components/common/Loader";
import Fab from "./components/common/Widgets/fab";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";
import ComingSoonTooltip from "./components/AdminModule/Dashboard/StartupDashboard/MentorMatchList/comingSoonTooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      fontFamily: "Special Elite !important",
    },
  },
}));

// import FloatingAction from './FloatingAction';
function App() {
  const classes = useStyles();

  const [cursor, setCursor] = useState(false);
  const [dislexia, setDislexia] = useState(false);
  const [line, setLine] = useState(false);
  const [wordS, setWordS] = useState(false);
  const [letterS, setLetterS] = useState(false);
  const [fontS, setFontS] = useState(false);

  const html = document.getElementsByTagName("html")[0];
  const toggleTheme = (theme) => {
    html.dataset.theme = theme;
  };

  return (
    <div
      className={clsx(
        `App ${cursor ? "largeCursor" : ""} ${dislexia ? "dislexia" : ""} ${
          line ? "lineHeight" : ""
        }`
      )}
    >
      <ComingSoonTooltip />
      <Loader />
      <Fab
        fontS={fontS}
        setFontS={setFontS}
        letterS={letterS}
        setLetterS={setLetterS}
        wordS={wordS}
        setWordS={setWordS}
        toggleTheme={toggleTheme}
        line={line}
        setLine={setLine}
        dislexia={dislexia}
        setDislexia={setDislexia}
        cursor={cursor}
        setCursor={setCursor}
      />
      <ToastContainer
        // className="toaster-container"
        position="top-right"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
      />
      <AppRoutes />
      {/* <FloatingAction/> */}
    </div>
  );
}

export default App;
